import type { FaireProductEntity } from "../../entity_types/product";

export const p_cyxp5y5whc: FaireProductEntity = {
  token: "p_cyxp5y5whc",
  type: "product",
  name: "Striped Canvas Tote Bag - Large Capacity Beach and Shopping Shoulder Bag",
  brandToken: "b_8p6hzrhexg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f3eeb6ad3c9447192572d98f97c95bc2824523cd1f791040ab96583f7217336f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/538b4ba37130aaee47d48ad2d87377df4c0ae50318e16bb82d8e90efbbc11339.jpeg",
    "https://cdn.faire.com/fastly/205cc00041e65f89c4354bd1892ce094bba09fd916cd62862dcb2f4e0538a913.jpeg",
    "https://cdn.faire.com/fastly/be774f4dbecd78d43cd8fe6803510c10a4c20aa94063a416fcacabb147834231.jpeg",
    "https://cdn.faire.com/fastly/c87e6f1da0dfc78aafb5b340d8108a159eb3ae6aea9fe7fa2759695f5b9fe5e9.jpeg",
    "https://cdn.faire.com/fastly/aaa157a20d1468a4efffbf7d910047179f654724a1478468b5b227a070e677ca.jpeg",
    "https://cdn.faire.com/fastly/268620d999a82aab6243af7e46af67a46202b586d80ec95d0e0020d796687e43.jpeg",
    "https://cdn.faire.com/fastly/a5a2ac2ad086ce6f7be8d47475fd66ef1597efc1598d6c9765e8b255ec772372.jpeg",
    "https://cdn.faire.com/fastly/535af3afde4bfa842e585e9983bde3939d7104bb352311a256358d04cb3f956a.jpeg",
    "https://cdn.faire.com/fastly/733a2b02af258cae5738c6493f2755a40432f389d57e12765b20779a0adfadb3.jpeg",
    "https://cdn.faire.com/fastly/2a15ac8270eb64313ed747c5c08fc0d5f446a7d01111b7346ca0366a7d96259b.jpeg",
    "https://cdn.faire.com/fastly/1ec3206937ec7882328d2466f416b1337c787dfc56f584725be1dee53f36f0e3.jpeg",
  ],
  priceDollars: 19.39,
  description:
    "Elevate your everyday style with our Women's Blue and White Striped Canvas Tote Bag. This tote features a classic, eye-catching blue and white vertical stripe pattern that never goes out of style, making it a perfect addition to any wardrobe. Crafted from durable canvas, this bag is designed to withstand the rigors of daily use, whether you're heading to the beach, hitting the shops, or carrying your gym essentials.\n\nMaterial:\n\n * 100% Canvas\n",
  tags: [],
  msrpDollars: 38.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:24.059Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
